module.exports = __webpack_public_path__ + "img/setSessuon.4f15273b.svg";